import React, { createRef, useState, useEffect } from "react";
import { Button, Modal, Form, InputGroup } from 'react-bootstrap';
import InputGroupText from "react-bootstrap/esm/InputGroupText";

import { Datatable } from '../../../../shared/datatable/Datatable';
import { TextInput } from "../../../../shared/form/FormInput";
import { Validators } from "../../../../shared/utils/Validators";

import { programmeList, programmeAdd, programmeDetail, programmeUpdate } from "../../../../shared/settings/apiConfig";
import { postApi, putApi } from "../../../../shared/services/apiHelper";

import './Programme.scss';

const Programme = (props) => {
    const dataTable = createRef();

    const getProgrammeForm = (programmename='') => {
        return {
            programmename: { value: programmename, valid: false, error: '', validators: [Validators.required()] }
        };
    };

    const [programmeForm, setProgrammeForm] = useState(getProgrammeForm());
    const [formValid, setFormValid] = useState(false);
    const [programmeModal, setProgrammeModal] = useState(false);
    const [programmeDetailData, setProgrammeDetailData] = useState({});
    const [message, setMessage] = useState({type: '', message: ''});
    const [search, setSearch] = useState("");
    const [formLoading, setFormLoading] = useState(false);

    const editAction = (id) => {
        const payload = {
            "field": ["id", "programmename"]
          }
        postApi(`${programmeDetail}/${id}`, payload).then((response) => {
            const data = response.data.data[0];
            setProgrammeDetailData(data);
            openProgrammeModal(data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const [config, setConfig] = useState({
        name: 'programme',
        url: programmeList,
        columns: [
            { name: 'Programme', property: 'programmename', sort: false, width: '90%' },
            {
                name: '', property: '', columnType: 'actions', width: '10%',
                actions: {
                    header: "",
                    row: [
                        {
                            type: 'edit',
                            action: editAction
                        }
                    ]
                }
            },
        ],
        field: ["id", "programmename"],
        filter: [],
        sort: [{ "field": "id", "direction": "asc" }],
        pagination: true,
    });

    const openProgrammeModal = (data) => {
        setProgrammeModal(true);
        if ( data ) {
            const formData = getProgrammeForm(data?.programmename || '');
            for (let key in formData) {
                formData[key] = Validators.validateFormControl(formData[key], formData[key].value)
            }
            setProgrammeForm(formData);
        } else {
            setProgrammeForm(getProgrammeForm());
        }
    }

    const closeProgrammeModal = () => {
        setProgrammeModal(false);
        setProgrammeDetailData({});
    };
    useEffect(() => {
        if(programmeModal == false) {
            dataTable.current?.searchData([])
        }
    }, [programmeModal]);

    useEffect(() => {
        setFormValid(Validators.validateForm(programmeForm));
    }, [programmeForm]);

    const inputChange = (type, event) => {
        setProgrammeForm(prevState => {
            return {
                ...prevState,
                [type]: Validators.validateFormControl(prevState[type], event.target.value)
            }
        })
    };

    const addOrUpdateProgramme = (isUpdate, addAnotherProgramme=false, loadSubjects=false) => {
        let data = {
            "programmename": programmeForm.programmename.value
        };
        setFormLoading(true)

        if ( isUpdate ) {
            data["id"] = programmeDetailData.id
            putApi(programmeUpdate, { data }).then((response) => {
                setMessage({type: 'success', message: "Programme Updated Successfully"});


                setTimeout(() => {
                    setFormLoading(false)
                    closeProgrammeModal();
                    setMessage({type: '', message: ''});
                }, 2000);

            }).catch((error) => {
                setMessage({type: 'error', message: error.response.data.message[0].message});
                setTimeout(() => {
                    setFormLoading(false)
                    setMessage({type: '', message: ''});
                }, 2000);
            })
        } else {
            postApi(programmeAdd, { data }).then((response) => {
                setMessage({type: 'success', message: "Programme Added Successfully"});

                if ( addAnotherProgramme ) {
                    setProgrammeForm(getProgrammeForm());
                }

                setTimeout(() => {
                    if ( !addAnotherProgramme ) {
                        setFormLoading(false)
                        closeProgrammeModal();
                    }

                    setMessage({type: '', message: ''});

                    if ( loadSubjects ) {
                        props.history.push('/settings/subjects');
                    }
                }, 2000);

            }).catch((error) => {
                setMessage({type: 'error', message: error.response.data.message[0].message});
                setTimeout(() => {
                    setFormLoading(false)
                    setMessage({type: '', message: ''});
                }, 2000);
            })
        }
    }

    const clearData = () => {
        setSearch("");
        dataTable.current?.searchData([
            { field: 'programmename', value: "", op: 'LIKE', 'join': 'OR' }
        ]);
    }

    return (
        <div>
            <div className="departments w-100">
                <text className='screen-head'>Programmes</text>
                <div className="d-flex w-100 p-3 justify-content-between">
                    <div >
                        {/* <text className="text-primary">Programme List</text> */}
                    </div>
                    <div className="w-60 d-flex gap-2 rightcont">
                        <InputGroup className="">
                            <InputGroupText className="search" >
                                <i class="fa fa-search ml-3" ></i>
                            </InputGroupText>
                            <span class="icon-envelope-o"></span>
                            <Form.Control className={`search`} type={'text'} style={{ borderRadius: '0px 5px 5px 0px', borderLeft: 'none' }} name={"search"} placeholder={"search by programme name"}
                                onChange={(event) => {
                                    setSearch(event.target.value);

                                    // TODO check if already had a filter
                                    if (event.target.value.length == 0) {
                                        dataTable.current?.searchData([]);
                                    }
                                }}
                                value={search}
                                onKeyPress={(event) => {
                                    if (event?.key === "Enter" && search)
                                        dataTable.current?.searchData([
                                            { field: 'programmename', value: search, op: 'LIKE', 'join': 'AND' }
                                        ])
                                }} />
                        </InputGroup> 
                        <button type="button" className="btn btn-secondary prg-btn" onClick={() => {clearData()}}>Clear</button>
                        <button type="button" onClick={() => { openProgrammeModal(); }} className="btn btn-primary w-50 prg-btn" >Add Programme</button>
                    </div>
                </div>
            </div>
            <div style={{ padding: '15px' }}>
                <Datatable ref={dataTable} config={config} />
            </div>

            <Modal className="departments" show={programmeModal} onHide={closeProgrammeModal} size="lg" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary" style={{ fontWeight: 'bold' }}>{programmeDetailData.id ? "Update Programme" : 'Add Programme'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <TextInput type={'text'} name={'programmename'} label={'Programme Name'} placeholder={'Programme Name'} isMandatory={true}
                        value={programmeForm.programmename.value} error={programmeForm.programmename.error} onChange={(event) => inputChange("programmename", event)} />

                    <div style={{ padding: '0px 20px 0px 20px' }}>
                        <div className="mt-5" style={{ textAlign: 'center', width: '100%' }}>
                            <p style={{ color: message.type === 'success' ? 'green' : '#A50050' }}>{message.message}</p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="d-flex" style={{ justifyContent: 'center' }}>
                    {
                        programmeDetailData.id ?
                            <Button disabled={!formValid || formLoading} onClick={() => addOrUpdateProgramme(true)}>Update Programme</Button> :
                            <>
                                <Button disabled={!formValid || formLoading} onClick={() => addOrUpdateProgramme(false, true)}>Create Programme and Add Another</Button>
                                <Button disabled={!formValid || formLoading} onClick={() => addOrUpdateProgramme(false, false, true)}>Create Programme and Load Subjects</Button>
                            </>
                    }
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default Programme;
